import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class MyToastrService {

  constructor(
    private toastr: ToastrService
  ) { }

  showSuccess(message: string, title = "") {
    this.toastr.success(message, title)
  }

  showInfo(message: string, title = "") {
    this.toastr.info(message, title)
  }

  showError(message: string, title = "") {
    this.toastr.error(message, title)
  }
}
